import { HttpClient } from './client/httpClient';
import { ErrorHandler } from './error/errorHandler';
import backendHttpClient from './client/backendHttpClient';
import apiErrorHandler from './error/apiErrorHandler';
import { SmppboxModel } from '../models/smppboxModel';
import { SmppboxStatusResponse } from './responses/smppboxResponse';
import { getCurrentTimestamp } from '../utils/datetimeUtils';

class SmppboxApi {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorHandler: ErrorHandler) {}

  public fetchSmppbox(serverId: string): Promise<SmppboxModel> {
    return this.httpClient.get<SmppboxStatusResponse>(`/servers/${serverId}/smppbox`)
      .then(response => this.mapToSmppboxModel(serverId, response))
      .catch(error => this.errorHandler.handleError(error, 'Failed to fetch smppbox status'));
  }

  private mapToSmppboxModel(serverId: string, statusResponse: SmppboxStatusResponse): SmppboxModel {
    return {
      serverId,
      status: statusResponse,
      fetchedAt: getCurrentTimestamp(),
    };
  }
}

export default new SmppboxApi(backendHttpClient, apiErrorHandler)
